import LocaleSwitcher from './localeSwitcher';

export default LocaleSwitcher;
